<template>
  <div>
    <div class="top">
      <Breadcrumb :options="breadcrumb" />
      <Wxts :wxtsList="wxtsList" />
    </div>

    <MyForm ref="form" :form="form" :rules="rules" :labelWidth="labelWidth" :formGroups="[{ formCtrl }]"
      :viewMode="viewMode" @onChange="onChange">
    </MyForm>

    <div class="btns">
      <SubmitBtn v-if="mode != 'view'" :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import mixin from "./mixin";
import Wxts from '../../../components/Wxts.vue';
export default {
  components: { Wxts },
  mixins: [detailMixin, mixin],
  data() {
    return {
      breadcrumb: [
        { name: "车辆管理", path: `/vehicle/manage` },
        { name: "车辆列表", path: `/vehicle/manage` },
        { name: "车辆添加" },
      ],
      wxtsList: [
        {
          name: '车辆资产余额=资产金额-资产金额×[N÷(摊销年限×12)]，N为车龄，以月为单位。'
        }
      ],
      labelWidth: "180px",
      form: {
        license: undefined,
        ton: undefined,
        buytime: undefined,
      },
      rules: {
        license: [
          { required: true, validator: this.checkLicense, trigger: "blur" },
        ],
        ton: [
          { required: true, message: "请填写核定载重", trigger: "blur" },
        ],
        // buytime: [
        //   { required: true, message: "请选择车辆购入时间", trigger: "blur" },
        // ],
        // asset: [
        //   { required: true, message: "请填写资产金额", trigger: "blur" },
        // ],
        // amortization: [
        //   { required: true, message: "请填写摊销年限", trigger: "blur" },
        // ],
      },
    };
  },
  methods: {},
  mounted() {
    this.getOptions();
    const { user_group_id } = this.user
    if (user_group_id == 5) {
      this.formCtrl.map(v => {
        if (v.keyName === 'fleet') {
          v.disabled = true
        }
      })
    }
  },
};
</script>

<style lang="less" scoped>
.btns {
  margin: 40px 0 60px 180px;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
}
</style>
